<div class="contact-page min-h-50">
  <div class="slider-bg-img gradient01 ">
    <div class="container">
      <nav class="py-4">
        <ol itemscope itemtype="http://schema.org/BreadcrumbList" class="breadcrumb breadcrumb-arrow breadcrumb-tdm mb-0">
          <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item fw-semibold">
            <meta itemprop="position" content="1">
            <a itemprop="item" [routerLink]="['/accueil']" role="button" routerLinkActive="router-link-active"><span itemprop="name">Accueil</span></a></li>
          <li itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem" class="breadcrumb-item camel-case-text fw-semibold">
            <meta itemprop="position" content="2">
            <span itemprop="name">Contactez-nous by TDM</span></li>
        </ol>
      </nav>
      <div class="row row-cols-md-2 row-cols-sm-1 ">
        <div class="slider-txt py-md-5 py-sm-2">
          <div class="h-100">
            <img width="1238" height="582" src="assets/logo/logo_bytdm_signature_blanc.png" class="logo-bytdm" alt="by TDM">
<!--            <h1 class="heading text-uppercase">Échangeons sur  <span style="color : #BADFFF"> votre projet </span></h1>-->
            <h1 class="heading text-uppercase">Prenez rdv avec <span style="color : #BADFFF">Pierre Arnaud</span>, fondateur de THE DOOR MAN</h1>
            <h6 class="description">Vous souhaitez améliorer la rentabilité de votre agence tout en restant indépendant ? Échangeons ensemble pour voir si la solution by TDM correspond à votre profil.</h6>
              <a href="https://outlook.office.com/book/RservezunchangeaveclefondateurdelasolutionByTDM@tdm.immo/?ismsaljsauthenabled"
                 target="_blank"
                 rel="noopener noreferrer"
                 class="btn btn-light btn-infra">
                Réserver un créneau avec Pierre Arnaud MAZZANTI
              </a>
          </div>
          <div>
          </div>
        </div>
        <div class="slider-img">
          <img width="575" height="570" style="border-radius: 50% 50% 0% 0%;"
               src="assets/resources/web/images/data/photo_agence_immobiliere_by_TDM.png" alt="by TDM">
        </div>
      </div>
    </div>
  </div>

  <div class="formulaire-bloc">
    <div class="container content">
      <div class="formulaire">
        <div class="tabs-content mt-4">
          <div [formGroup]="contactForm">
            <div class="form-group">
              <div class="row my-3">
                <div class="col-sm-6 mb-1">
                  <label for="nom" class="form-label">Nom *</label>
                  <input placeholder="Ex : Dupont" type="text" class="form-control" id="nom" formControlName="nom" required>
                  <small  class="text-danger" *ngIf="contactForm.get('nom')?.touched && contactForm.get('nom')?.errors?.['required']">Le nom est obligatoire.</small>
                </div>
                <div class="col-sm-6 mb-1">
                  <label for="prenom" class="form-label">Prénom *</label>
                  <input placeholder="Ex : Marc" type="text" class="form-control" id="prenom" formControlName="prenom" required>
                  <small  class="text-danger" *ngIf="contactForm.get('prenom')?.touched && contactForm.get('prenom')?.errors?.['required']">Le prenom est obligatoire.</small>
                </div>
              </div>
              <div class="row my-3">
                <div class="col-sm-6 mb-1">
                  <label for="tel" class="form-label">Téléphone *</label>
                  <input placeholder="Ex : 0602030405" type="tel" class="form-control" id="tel" formControlName="tel" required>
                  <small  class="text-danger" *ngIf="contactForm.get('tel')?.touched && contactForm.get('tel')?.errors?.['required']">Le téléphone est obligatoire.</small>
                </div>
                <div class="col-sm-6 mb-1">
                  <label for="email" class="form-label">Email *</label>
                  <input placeholder="Ex : marc.dupont@mail.com" type="email" class="form-control" id="email" formControlName="email" required>
                  <small  class="text-danger" *ngIf="contactForm.get('email')?.touched && contactForm.get('email')?.errors?.['required']">L’email est obligatoire.</small>
                </div>
              </div>
              <div class="row my-3">
                <div class="col-sm-6 mb-1">
                  <label for="nomAgence" class="form-label">Nom de l'agence</label>
                  <input type="text" class="form-control" id="nomAgence" formControlName="nomAgence">
                </div>
                <div class="col-sm-6 mb-1">
                  <label for="ville" class="form-label">Ville</label>
                  <input type="text" class="form-control" id="ville" formControlName="ville">
                </div>
              </div>
              <h5 class="fw-bold my-4">Vous êtes :</h5>
              <div class="my-3">
                <div class="col-sm-12">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="vousetes" id="inlineRadio4" formControlName="vousetes"
                           value="1">
                    <label class="form-check-label" for="inlineRadio4">Agence immobilière indépendante</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="vousetes" id="inlineRadio5" formControlName="vousetes"
                           value="2">
                    <label class="form-check-label" for="inlineRadio5">Mandataire immobilier</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="vousetes" id="inlineRadio6" formControlName="vousetes"
                           value="3">
                    <label class="form-check-label" for="inlineRadio6">Autre</label>
                  </div>
                </div>

                <small class="text-danger"
                       *ngIf="contactForm.get('vousetes')?.touched && contactForm.get('vousetes')?.invalid">
                  Veuillez sélectionner votre profil.
                </small>
              </div>
              <h5 class="fw-bold my-4">Quand souhaitez-vous être rappelé ?</h5>
              <div class="my-3">
                <div class="col-sm-12">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="dispo" id="inlineRadio1" formControlName="dispo"
                           value="1">
                    <label class="form-check-label" for="inlineRadio1">Le matin</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="dispo" id="inlineRadio2" formControlName="dispo"
                           value="2">
                    <label class="form-check-label" for="inlineRadio2">L’après-midi</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="dispo" id="inlineRadio3" formControlName="dispo"
                           value="3">
                    <label class="form-check-label" for="inlineRadio3">Peu importe</label>
                  </div>
                </div>
                <small class="text-danger"
                       *ngIf="contactForm.get('dispo')?.touched && contactForm.get('dispo')?.invalid">
                  Veuillez sélectionner un créneau.
                </small>
              </div>
              <div class="row my-3">
                <label for="message" class="form-label">Votre message *</label>
                <textarea placeholder="Précisez votre demande en quelques mots..." class="form-control mx-2"
                          id="message" formControlName="message" required></textarea>
                <small class="text-danger"
                       *ngIf="contactForm.get('message')?.touched && contactForm.get('message')?.errors?.['required']">
                  Le message est obligatoire.
                </small>
              </div>
              <div class="my-4">
                <div class="py-3 form-check">
                  <input class="form-check-input" type="checkbox" value="" id="rgpd" formControlName="rgpd" required>
                  <label class="form-check-label" for="rgpd">
                    J'accepte que mes données personnelles soient traitées par THE DOOR MAN pour
                    donner suite à ma demande. *
                  </label>
                </div>
                <small class="text-danger"
                       *ngIf="contactForm.get('rgpd')?.touched && contactForm.get('rgpd')?.invalid">
                  Vous devez accepter le traitement de vos données personnelles.
                </small>
              </div>
              <div class="my-3">
                <button
                  class="btn btn-gold px-4 py-2"
                  (click)="submitFormContact()">
                  Envoyer
                </button>
              </div>
              <div class="my-4">
                <p class="condition">
                  En envoyant cette demande, j'accepte que mes données personnelles soient utilisées pour me recontacter
                  dans le cadre de la demande indiquée dans ce formulaire.<br>
                  Aucun autre traitement ne sera effectué avec mes informations.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
